import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'semantic-ui-react'
import ProfileSettingsService from '~/api/services/profileSettings'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import TwoFaComp from '~/components/TwoFaComp'
import { useAuth } from '~/routes/components/AuthProvider'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'

interface Props {
  isDialogOpen: boolean
  handleClose: () => void
  isDraft: boolean
  onSubmit: (code: string) => void
  scheduled?: Nullable<string>
  recipientsRef: React.MutableRefObject<HTMLDivElement>
  watch: (name: string) => any
}

const SendNewsletterDialog:React.FC<Props> = (props) => {
  const {
    isDialogOpen,
    handleClose,
    isDraft,
    onSubmit,
    scheduled,
    watch,
    recipientsRef
  } = props
  const { t } = useTranslation()
  const { systemData: { logged: { tfaType } } } = useAuth()
  const farmerGroupIds = watch('farmerGroups') || []

  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')

  useEffect(() => {
    if(isDialogOpen && (tfaType === 'email' || tfaType === 'sms')) {
      handleSendCode()
    }
  }, [isDialogOpen, isDraft])

  async function handleSendCode() {
    try {
      await ProfileSettingsService.sendCode()
      notify(t('Code sent'), 'success')
    } catch (error) {
      handleErrors(error)
    }
  }

  function getMessage() {
    const farmerGroupNames = []
    farmerGroupIds.map(farmerGroupId => {
      const element = recipientsRef.current?.querySelector(`a.ui.label[value="${farmerGroupId}"]`);
      if(element) {
        farmerGroupNames.push(element.textContent)
      }
    })
    farmerGroupNames.join(', ')
    if(scheduled) {
      return t('Sending out the newsletter for the farmers group [{{farmerGroupNames}}] is planned for {{scheduled}}.', { farmerGroupNames, scheduled })
    }
    return t('Sending out the newsletter for the farmers group [{{farmerGroupNames}}]', { farmerGroupNames })
  }
  
  return <Dialog
    isDialogOpen={isDialogOpen}
    textClose={t('Abort')}
    handleClose={() => handleClose()}
    disableSubmit={!correctTfaCode}
    style={{ width: 800 }}
    textSubmit={isDraft ? t('Draft') : scheduled ? t('Plan') : t('Send')}
    handleSubmit={() => onSubmit(tfaCode)}
    textContent={<div>
      <Message info>
        <div>{getMessage()}</div>
      </Message>
      <TwoFaComp
        onChangeTfaCode={(code) => setTfaCode(code)}
        onChangeCorrectTfaCode={(correctTfaCode) => setCorrectTfaCode(correctTfaCode)}
      />
    </div>}
    textHeader={t('Planning newsletter distribution')}
    type={'abort'}
  />
}
export default SendNewsletterDialog